import AssessmentTemplateCard from "@/shared/components/assessment/AssessmentTemplateCard/AssessmentTemplateCard";
import ccStyle from "./style.module.css";
import AssessmentTemplateBarChartComponent from "@/shared/components/charts/BarChart/AssessmentTemplateBarChartComponent";
import {
  ICompositeInterviewQuestion,
  IAssessmentComposite,
} from "@/modules/assessments/hooks/use-get-assessment-composites-by-invite.hook";
import MarkdownPreviewCustom from "@/ui-components/commonComponents/MarkdownPreviewCustom/MarkdownPreviewCustom";
import SubCompositeCard from "../SubCompositeCard/SubCompositeCard";

interface ICompositeCardProps {
  cardStyle?: React.CSSProperties;
  cardClassName?: string;
  showInterviewGuide?: boolean;
  composite: IAssessmentComposite;
}

export default function CompositeCard({
  cardStyle,
  cardClassName,
  showInterviewGuide = false,
  composite,
}: ICompositeCardProps) {
  return (
    <AssessmentTemplateCard
      description={composite.definition}
      containerStyle={cardStyle}
      className={cardClassName}
      compositeScore={composite.finalScore}
      compositeTitle={composite.title}
      icon={composite.icon}
      hasSubComposite={!!composite.subComposites && !showInterviewGuide}
    >
      <AssessmentTemplateBarChartComponent
        usersChartData={[
          {
            value: composite.finalScore,
          },
        ]}
        min_max={[0, 5]}
      />
      {!showInterviewGuide &&
        composite.subComposites &&
        composite.subComposites.map((subComposite) => (
          <SubCompositeCard key={subComposite.compositeKey} composite={subComposite} />
        ))}
      {composite.interviewGuide && showInterviewGuide && (
        <>
          <div className={ccStyle.fullBleedDivider} aria-hidden="true" />
          <div>
            <div>
              <h3 className={ccStyle.interviewGuideTitle}>Questions</h3>
              {composite.interviewGuide.questions.map((interviewQuestion: ICompositeInterviewQuestion) => (
                <section
                  key={`${composite.compositeKey}-${interviewQuestion.rank}`}
                  className={ccStyle.interviewQuestionContainer}
                >
                  <span className={ccStyle.interviewQuestionRank}>{interviewQuestion.rank}.</span>
                  <div className={ccStyle.interviewQuestion}>
                    <MarkdownPreviewCustom source={interviewQuestion.body} style={{ fontWeight: 400 }} />
                  </div>
                </section>
              ))}
            </div>
          </div>
        </>
      )}
    </AssessmentTemplateCard>
  );
}
